import { Stream, StreamEl, theme } from '@mi-front/ui';
import { desaturate } from 'polished';
import { useStreamUserDefinedRange } from '../../../stores/stream-screen.store';
import { useRangeAuditResults } from '../useRangeAuditResults';
import { PreviewMarker } from './PreviewMarker';

export function AuditPreviewMarkers() {
  const range = useStreamUserDefinedRange();
  const { data } = useRangeAuditResults();

  return (
    <Stream
      showAxis={false}
      height={12}
      range={range}
      renderHtml={() => (
        <>
          {data.matches.map((match, index) => (
            <div key={index} data-testid={AuditPreviewMarkers.matchTestId}>
              <StreamEl ts={new Date(match.datetime).valueOf()}>
                <PreviewMarker color={desaturate(0.2, theme.orange)} />
              </StreamEl>
            </div>
          ))}
          {data.liveMentions.map((mention, index) => (
            <div key={index} data-testid={AuditPreviewMarkers.liveMentionTestId}>
              <StreamEl ts={new Date(mention.datetime).valueOf()}>
                <PreviewMarker color={desaturate(0.2, '#5a5fd3')} />
              </StreamEl>
            </div>
          ))}
          {data.adoverlays.map((adoverlay, index) => (
            <div key={index} data-testid={AuditPreviewMarkers.adoverlayTestId}>
              <StreamEl ts={new Date(adoverlay.date).valueOf()}>
                <PreviewMarker color={desaturate(0.2, '#2bcf57')} />
              </StreamEl>
            </div>
          ))}
        </>
      )}
    />
  );
}

AuditPreviewMarkers.matchTestId = 'audit-match-preview-marker';
AuditPreviewMarkers.liveMentionTestId = 'audit-live-mention-preview-marker';
AuditPreviewMarkers.adoverlayTestId = 'audit-ad-overlay-preview-marker';
